export const HOMOLOG_HEADER = 'x-dg-homolog';

/**
 * Negociação de contrato da API (ADR-0013). A ausência deste header significa o contrato
 * legado, em reais; esta versão é a que trafega valores monetários em centavos.
 *
 * O `adotarOrcamento` do carrinho divide todos os valores por 100, então o front SÓ está
 * correto se pedir centavos explicitamente — sem o header ele receberia reais e mostraria
 * 1/100 do preço no checkout.
 */
export const API_VERSION_HEADER = 'x-dg-api-version';
export const API_VERSION_CENTAVOS = '2026-08-12';

export default {
  HOMOLOG_HEADER,
  API_VERSION_HEADER,
  API_VERSION_CENTAVOS
}
